$bog_blitz_admin_editor $mol_list
	quiz_land null
	rows <= editor_rows /
	Title_input $mol_string_button
		hint @ \Quiz title
		value? <=> quiz_title? \
	Settings $mol_list
		rows /
			<= Manual_mode_row $mol_labeler
				title @ \Manual mode (host controls transitions)
				content / <= Manual_mode $mol_check_box
					checked? <=> manual_mode? false
			<= Time_read_row $mol_labeler
				title @ \Read time (sec)
				content / <= Time_read $mol_number
					value? <=> time_read? 5
			<= Time_answer_row $mol_labeler
				title @ \Answer time (sec)
				content / <= Time_answer $mol_number
					value? <=> time_answer? 10
			<= Time_reveal_row $mol_labeler
				title @ \Reveal time (sec)
				content / <= Time_reveal $mol_number
					value? <=> time_reveal? 5
			<= Time_leaderboard_row $mol_labeler
				title @ \Leaderboard time (sec)
				content / <= Time_leaderboard $mol_number
					value? <=> time_leaderboard? 10
			<= Points_base_row $mol_labeler
				title @ \Points per answer
				content / <= Points_base $mol_number
					value? <=> points_base? 100
			<= Time_multiplier_row $mol_labeler
				title @ \Score multiplier for reaction
				content / <= Time_multiplier $mol_number
					value? <=> time_multiplier? 1.5
	Add_question $mol_button_major
		title @ \Add Question
		click? <=> add_question? null
	Question*0 $bog_blitz_admin_question
		number <= question_number*0 0
		question_text? <=> question_text*? \
		question_type? <=> question_type*? \choice
		delete? <=> delete_question*? null
		option_rows <= option_rows* /
		add_option? <=> add_option*? null
		correct_text? <=> correct_text*? \
		question_image_files? <=> question_image_files*? /
		question_image_uri <= question_image_uri* \
		remove_image? <=> remove_question_image*? null
	Option*0 $bog_blitz_admin_option
		option_text? <=> option_text*? \
		is_correct? <=> is_correct*? false
		delete? <=> delete_option*? null
		option_image_files? <=> option_image_files*? /
		option_image_uri <= option_image_uri* \
		remove_image? <=> remove_option_image*? null
